import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import TagManager from 'react-gtm-module'
import { useTranslation } from 'react-i18next'

import { HeaderSsp, Footer } from '../../components/index'
import { checkIsMobile } from 'shared'
import SspContext from '../../contexts/SspContext'
import { OutOfServiceModal } from 'shared/components/modals/OutOfServiceModal'
import { menuItems } from '../../constants/menuItems'
import './StartPage.scss'
import { appRoutes } from '../../constants/routes'
import DixaChatbot from 'selfServicePortal/components/DixaChatbot/DixaChatbot'
import appConfig from 'app.config'
import { CustomerStatus } from 'selfServicePortal/interfaces/i-api-customer'
import { ICreditBalance, IDepositData, IMSAgreementStatus } from 'selfServicePortal/interfaces/i-api-creaditCard'

export const StartPage = () => {
	const { t } = useTranslation()
	const isMobile = checkIsMobile()
	const { component, error, setComponent, customerData, overviewData } =
		useContext(SspContext)
	const location = useLocation()
	const navigate = useNavigate()
	const [agreementState, setAgreementState] = useState<
			ICreditBalance | IDepositData | undefined
			>(undefined)

	const tagManagerArgs = {
		dataLayer: {
			userId: '001',
			userProject: 'project',
			page: '/login',
		},
	}

	React.useEffect(() => {
		TagManager.dataLayer(tagManagerArgs)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (location.pathname === appRoutes.sepadirectdebit) {
			setComponent(menuItems[0].items[6])
		}
	}, [location.pathname, component, setComponent])
	useEffect(() => {
			setAgreementState(overviewData)
		}, [overviewData])

	return (
		<div className="startpage-outer">
			<HeaderSsp />
			{customerData && !(customerData.status === CustomerStatus.Closed ||
						(agreementState as IDepositData)?.agreementStatus ===
							IMSAgreementStatus.Closed) && (
				<DixaChatbot
					firstName={customerData.firstName}
					lastName={customerData.lastName}
					email={customerData.email}
					market={appConfig.country}
				/>
			)}
			<OutOfServiceModal
				showModal={error !== undefined}
				onClick={() => {
					navigate('/logout')
				}}
				icon=""
				message={
					error?.message! === 'Network Error'
						? 'Network Error'
						: t('NoAccounts')
				}
			/>

			<div className="startpage-container">
				<div
					className={
						!isMobile ? 'startpage' : 'startpage startpage-mobile'
					}>
					{component?.component}
				</div>
				<Footer />
			</div>
		</div>
	)
}
